import * as React from "react";
import { css } from "@emotion/react";
import { numberToCurrency } from "main/javascripts/utils/StringUtil";
import { borderRadius } from "main/javascripts/styles/base/borderStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import {
  accentColor,
  borderColor,
} from "main/javascripts/styles/base/colorStyle";
import {
  fontSize,
  fontWeight,
} from "main/javascripts/styles/base/typographyStyle";

export interface IProps {
  originName: string;
  destinationName: string;
  originId: number;
  price: number;
  priceCurrency: string;
  onClick: any;
}

export const FlightReferencePriceLink: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const {
    originName,
    destinationName,
    price,
    priceCurrency,
    originId,
    onClick,
  } = props;

  const onClickLink: (e: any) => void = (e: any): void => {
    e.preventDefault();
    onClick(originId);
  };

  return (
    <a onClick={onClickLink} css={linkStyle}>
      <div css={dataBlockStyle}>
        <div css={destinationStyle}>
          <span css={textBlockStyle}>{originName}</span>
          <span css={flightArrowStyle} />
          <span css={textBlockStyle}>{destinationName}</span>
        </div>
        <div css={priceStyle}>
          <span css={labelStyle}>往復</span>{" "}
          {numberToCurrency(price, priceCurrency)} 〜
        </div>
      </div>
      <div css={arrowBlockStyle}>
        <div css={arrowStyle} />
      </div>
    </a>
  );
};

const linkStyle = css`
  width: 100%;
  cursor: pointer;
  background: #fff;
  border-radius: ${borderRadius.normal};
  box-sizing: border-box;
  margin: ${space.atom};
  display: flex;
  transition: opacity 0.4s ease;
  ${moreThanBreakpoint("tablet")} {
    width: calc(50% - ${space.atom2x});
  }
  &:hover {
    opacity: 0.9;
  }
`;
const dataBlockStyle = css`
  padding: ${space.atom};
`;
const destinationStyle = css`
  padding: ${space.atom} ${space.atom} ${space.atom};
  flex: 1;
  letter-spacing: 0.1em;
  font-weight: ${fontWeight.bold};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: ${fontSize.caption};
  ${moreThanBreakpoint("tablet")} {
    font-size: ${fontSize.body};
  }
`;
const priceStyle = css`
  padding: 0 ${space.atom} ${space.atom0_5x};
  font-size: ${fontSize.mediumHeading};
  font-weight: ${fontWeight.bold};
  color: ${accentColor.secondaryColor};
  display: flex;
  align-items: center;
`;
const arrowBlockStyle = css`
  padding: ${space.atom};
  margin-left: auto;
  display: flex;
  align-items: center;
  border-left: 1px solid ${borderColor.primaryLightColor};
  ${moreThanBreakpoint("desktop")} {
    padding: ${space.atom2x};
  }
`;
const arrowStyle = css`
  background: ${accentColor.primaryColor};
  color: #fff;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 46%;
    width: 0.5rem;
    height: 0.5rem;
    transform: translate(-50%, -50%) rotate(45deg);
    border: 2px solid #fff;
    border-left: 0;
    border-bottom: 0;
    box-sizing: border-box;
  }
`;
const flightArrowStyle = css`
  position: relative;
  width: 2.5rem;
  height: 2px;
  margin: 0 ${space.atom1_5x} 0 ${space.atom1_5x};
  background: ${borderColor.secondaryLightColor};
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    width: 0.75rem;
    height: 0.75rem;
    transform: translateY(-50%) rotate(45deg);
    border: 2px solid ${borderColor.secondaryLightColor};
    border-left: 0;
    border-bottom: 0;
    box-sizing: border-box;
  }
  ${moreThanBreakpoint("desktop")} {
    width: 3.5rem;
  }
`;
const labelStyle = css`
  border: 1px solid;
  font-size: ${fontSize.smallest};
  padding: 0.0625rem 0.5rem;
  margin-right: ${space.atom};
  margin-left: -${space.atom0_5x};
  border-radius: ${space.atom2x};
  font-weight: ${fontWeight.regular};
`;
const textBlockStyle = css`
  display: inline-block;
`;
